import classcat from "classcat";
import Markdown from "markdown-to-jsx";
import React from "react";

import { Checkbox } from "@touchtech/baselayer-ui";
import { Button, Label } from "@touchtech/web-baselayer-ui";

import Modal from "../Modal";
import SignUpFormField from "./SignUpFormField";
import css from "./SignUpModal.module.css";
import useManageSignUpModal from "./hooks/useManageSignUpModal";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const SignUpModal = ({ isOpen, onClose }: Props) => {
  const {
    isAgreementChecked,
    isAgreementRequired,
    isConfirmButtonDisabled,
    handleConfirm,
    handleCheckedToggle,
    handleCancel,
    formState,
    handleFormFieldChange,
    fieldsValidation,
    handleLinkClick,
    title,
    description,
    agreement,
    isPending,
    t,
  } = useManageSignUpModal();

  return (
    <Modal isOpen={isOpen} onClose={onClose} className={css.modal}>
      <div className={css.content}>
        <h1 className={classcat(["text-headline-5xl", css.title])}>{title}</h1>
        <span className={classcat(["text-label-xl", css.text])}>
          {description}
        </span>
        <div className={css.inputsContainer}>
          {Object.values(formState).map((option) => (
            <SignUpFormField
              key={option.id}
              field={option}
              onChange={handleFormFieldChange}
              validation={fieldsValidation}
            />
          ))}
        </div>
        {!!agreement?.length && (
          <div className={css.agreementContainer}>
            <div
              className={classcat([
                css.checkboxWrapper,
                { [css.checked]: isAgreementChecked },
              ])}
            >
              <Checkbox
                size="medium"
                checked={isAgreementChecked}
                className={classcat({
                  [css.checkboxError]: isAgreementRequired,
                })}
                onChange={handleCheckedToggle}
              />
            </div>
            <Label>
              <Markdown
                options={{
                  overrides: {
                    a: {
                      props: {
                        onClick: handleLinkClick,
                        className: css.hyperlink,
                      },
                    },
                  },
                }}
              >
                {agreement}
              </Markdown>
            </Label>
          </div>
        )}
        <div className={css.buttonsContainer}>
          <Button
            width="full"
            className={classcat([
              { [css.confirmButton]: !isConfirmButtonDisabled },
              { [css.disabledButton]: isConfirmButtonDisabled },
            ])}
            sizing="lg"
            onClick={handleConfirm}
            state={isPending ? "pending" : undefined}
          >
            {t("Confirm")}
          </Button>
          <Button
            width="full"
            className={css.cancelButton}
            sizing="lg"
            onClick={handleCancel}
          >
            {t("Cancel")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SignUpModal;
